export type ReportModuleKey =
  | 'scm'
  | 'sales'
  | 'fin'
  | 'inventory'
  | 'mfg'
  | 'qms'
  | 'prj'
  | 'epc'
  | 'asset'
  | 'pmv'
  | 'hr'
  | 'education'
  | 'grc'
  | 'analytics';

export type ReportKind = 'runner' | 'legacy' | 'dashboard';

export type ReportFilterType = 'text' | 'dateRange' | 'select' | 'number' | 'project';

export interface ReportFilterField {
  key: string;
  label: string;
  type: ReportFilterType;
  options?: Array<{ value: string; label: string }>;
  placeholder?: string;
  /** When type is project: allow clearing selection (default true). */
  allowClear?: boolean;
}

export interface ReportColumnDef {
  key: string;
  title: string;
  dataIndex: string;
  width?: number;
  align?: 'left' | 'right' | 'center';
  sortable?: boolean;
  format?: 'text' | 'date' | 'money' | 'number' | 'percent';
  /** When set, cell links to this path with `:id` replaced by row.id */
  drillPath?: string;
}

export interface ReportDefinition {
  id: string;
  module: ReportModuleKey;
  title: string;
  description: string;
  route: string;
  kind: ReportKind;
  permissionCodes: string[];
  ecsPackKey?: string;
  dataSource?: string;
  capabilities: {
    print?: boolean;
    exportCsv?: boolean;
    exportXlsx?: boolean;
    savedViews?: boolean;
    schedule?: boolean;
    drillThrough?: boolean;
  };
  filterSchema?: ReportFilterField[];
  columnSchema?: ReportColumnDef[];
  /**
   * Optional alternate columns when the report `view` filter is set
   * (e.g. Tax Invoice Register detail vs customer summary).
   */
  columnSchemaByView?: Record<string, ReportColumnDef[]>;
  sortDefaults?: { sortBy: string; sortDir: 'ASC' | 'DESC' };
  defaultFilters?: Record<string, unknown>;
}

export interface ReportQueryResult {
  rows: Record<string, unknown>[];
  total: number;
  /** Totals for the current page of rows. */
  totals?: Record<string, number>;
  /** Totals across all rows matching the current filters. */
  grandTotals?: Record<string, number>;
  page: number;
  pageSize: number;
}

export const REPORT_MODULE_LABELS: Record<ReportModuleKey, string> = {
  scm: 'Supply Chain',
  sales: 'Growth & Revenue',
  fin: 'Finance',
  inventory: 'Inventory',
  mfg: 'Manufacturing',
  qms: 'Quality',
  prj: 'Projects',
  epc: 'EPC',
  asset: 'Assets',
  pmv: 'PMV',
  hr: 'HR',
  education: 'Education',
  grc: 'GRC',
  analytics: 'Analytics',
};
